/*
  Sport rail: WAI-ARIA tabs over horizontally scrolling product tracks.
  - Arrow keys move between tabs; the active tab scrolls into view.
  - Prev / next buttons page the visible track by one card width.
  - The progress bar and the CTA follow the active track.
*/
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.psReady) return;
    root.dataset.psReady = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var prev = root.querySelector('[data-ps-prev]');
    var next = root.querySelector('[data-ps-next]');
    var bar = root.querySelector('[data-ps-bar]');
    var cta = root.querySelector('[data-ps-cta]');
    var ctaLabel = root.querySelector('[data-ps-cta-label]');

    function activeTrack() {
      var panel = root.querySelector('[role="tabpanel"]:not([hidden])');
      return panel ? panel.querySelector('[data-ps-track]') : null;
    }

    function update() {
      var t = activeTrack();
      if (!t) return;
      var max = t.scrollWidth - t.clientWidth;
      var ratio = t.scrollWidth ? t.clientWidth / t.scrollWidth : 1;
      var pos = max > 0 ? t.scrollLeft / max : 0;
      if (bar) {
        var w = Math.max(0.2, Math.min(1, ratio));
        bar.style.setProperty('--w', (w * 100) + '%');
        bar.style.setProperty('--x', ((1 - w) / w * pos * 100) + '%');
      }
      if (prev) prev.disabled = t.scrollLeft <= 2;
      if (next) next.disabled = t.scrollLeft >= max - 2;
    }

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
      tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      if (cta) cta.href = tab.dataset.ctaUrl || cta.href;
      if (ctaLabel && tab.dataset.ctaLabel) ctaLabel.textContent = tab.dataset.ctaLabel;
      var t = activeTrack();
      if (t) t.scrollLeft = 0;
      update();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var j = null;
        if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = tabs.length - 1;
        if (j === null) return;
        e.preventDefault();
        select(tabs[j], true);
      });
    });

    function page(dir) {
      var t = activeTrack();
      if (!t) return;
      var card = t.firstElementChild;
      var gap = parseFloat(getComputedStyle(t).columnGap) || 0;
      var step = card ? card.getBoundingClientRect().width + gap : t.clientWidth;
      t.scrollBy({ left: dir * step, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });

    root.querySelectorAll('[data-ps-track]').forEach(function (t) {
      t.addEventListener('scroll', update, { passive: true });
    });
    window.addEventListener('resize', update);
    update();
  }

  function boot() { document.querySelectorAll('[data-ps-srail]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
